import { useState, useCallback, useMemo, useEffect } from 'react';
import {
  identity,
  constant,
  flow,
  flatMap,
  keyBy,
  pickBy,
  keys,
  mapValues,
  pick,
  every,
} from 'lodash/fp';

export default (isOpen, designId, containers, updatePricing, fields, pricingOptions) => {
  const [options, setOptions] = useState(fields);

  const [selectedItems, setSelectedItems] = useState({});

  useEffect(() => {
    setSelectedItems(flow(
      flatMap('items'),
      keyBy(identity),
      mapValues(constant(false)),
    )(containers));
  }, [designId, containers]);

  const leafItems = useMemo(() => flow(
    pickBy(identity),
    keys,
  )(selectedItems), [selectedItems]);

  const [pricing, setPricing] = useState({
    measureCredit: 0,
    installationCost: 0,
    totalInstallationCost: 0,
    surcharges: [],
  });

  useEffect(() => {
    if (isOpen) {
      updatePricing(leafItems, options).then(setPricing);
    }
  }, [JSON.stringify(leafItems), JSON.stringify(pick(pricingOptions)(options)), isOpen]);

  const toggleItem = useCallback((itemId) => {
    const item = selectedItems[itemId] || false;

    setSelectedItems({
      ...selectedItems,
      [itemId]: !item,
    });
  }, [selectedItems, setSelectedItems]);

  const toggleAll = useCallback(() => {
    setSelectedItems(mapValues(constant(!every(identity, selectedItems)), selectedItems));
  }, [selectedItems, toggleItem]);

  const setOption = useCallback((option, value) => {
    setOptions({
      ...options,
      [option]: value,
    });
  }, [options]);

  return {
    options,
    setOption,
    selectedItems,
    toggleItem,
    toggleAll,
    pricing,
  };
};
